import { useState } from "react";
import { Link } from "react-router-dom";

const faqs = [
  {
    q: "动漫网是什么？",
    a: "动漫网是一个专注动漫导航与资讯的中文门户网站，聚合了热血、恋爱、治愈、科幻等八大分类频道，以及热门新番与最新动漫资讯，为动漫爱好者提供一站式浏览体验。",
  },
  {
    q: "如何快速进入动漫网主页？",
    a: "你只需将本页面收藏到浏览器书签即可，动漫网提供直达链接与网址收藏指引，打开收藏即可快速进入主页，浏览全部频道与分类，无需反复搜索。",
  },
  {
    q: "动漫网有哪些分类频道？",
    a: "动漫网覆盖热血、恋爱、治愈、科幻、搞笑、冒险、奇幻、日常八大分类频道，每个频道都聚合了对应题材的动漫推荐与资讯文章。",
  },
  {
    q: "动漫网的资讯多久更新一次？",
    a: "动漫网会持续更新新番前瞻、经典盘点、深度评测等资讯内容，并同步热门新番推荐，让你第一时间掌握动漫圈的最新动态。",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl text-foreground-900 md:text-3xl">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">关于动漫网的使用常见疑问解答</p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</span>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition ${isOpen ? "rotate-180 bg-primary-100 text-primary-600" : ""}`}>
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {isOpen && <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>}
              </div>
            );
          })}
        </div>

        <p className="mt-6 text-center text-sm text-foreground-600">
          还有其他问题？<Link to="/about" className="font-medium text-primary-600 transition hover:text-primary-700">联系我们</Link>
        </p>
      </div>
    </section>
  );
}